import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

// Erros que JÁ TÊM tela dedicada explicando o que aconteceu: usuário desativado (/blocked-user),
// fora do horário de acesso (/fora-horario-acesso) e sessão encerrada. Para esses, o toast só
// repetiria a informação — e repetiria pelo código cru, que não diz nada a quem está usando.
// A tela explica e oferece o que fazer; o toast, não.
const CODIGOS_COM_TELA_PROPRIA = [
	"ERR_USER_INACTIVE",
	"ERR_USER_OUT_OF_SCHEDULE",
	"ERR_SESSION_EXPIRED",
];

const temTelaPropria = data => {
	const code = data?.message || data?.error;
	return (
		CODIGOS_COM_TELA_PROPRIA.includes(code) ||
		data?.inactive === true ||
		data?.outOfSchedule === true
	);
};

const toastError = err => {
	const data = err?.response?.data;

	if (temTelaPropria(data)) {
		return;
	}

	// Código estável para tradução (backendErrors.*). `details`/`meta` trazem o
	// motivo real vindo do backend (ex.: o que a Meta retornou).
	const code = data?.message || data?.error;
	const details = data?.details;
	const detailText =
		typeof details === "string" ? details : details?.message || data?.meta?.message;

	// 413 não vem do backend: quem responde é o nginx, com HTML e sem `message` — o
	// upload passou do `client_max_body_size` da máquina e nunca chegou ao Node. Sem
	// este ramo o atendente lia "An error occurred!" e não tinha o que fazer com isso.
	if (!code && err?.response?.status === 413) {
		toast.error(i18n.t("backendErrors.ERR_MIDIA_MUITO_GRANDE"), {
			toastId: "ERR_MIDIA_MUITO_GRANDE",
		});
		return;
	}

	// Erro sem código do backend (DOMException, falha de rede, timeout): o texto
	// genérico é tudo que temos pra mostrar, mas sem toastId cada ocorrência
	// empilhava um aviso novo na tela. O console guarda o motivo real.
	if (!code) {
		console.error("Erro sem código do backend:", err);
		toast.error("An error occurred!", { toastId: "erro-generico" });
		return;
	}

	const base = i18n.exists(`backendErrors.${code}`)
		? i18n.t(`backendErrors.${code}`)
		: code;
	// Mensagem amigável + motivo real (quando houver), pra entender sem abrir log.
	const message = detailText ? `${base} — ${detailText}` : base;

	toast.error(message, { toastId: code });
};

export default toastError;
